import DallE3FinishPage from './DallE3FinishPage'

export default DallE3FinishPage
